import {
  TabbedForm,
  FormTab,
  ReferenceArrayInput,
  SelectArrayInput,
  TextInput,
  ImageInput,
  ImageField,
  NumberInput,
  LongTextInput
} from "react-admin";
import React from "react";
import { required } from "../../services/validate";

const SaleAgencyForm = props => {
  return (
    <TabbedForm {...props}>
      <FormTab label="saleagency.tab.general">
        <TextInput source="name" validate={[required()]} />
        <ReferenceArrayInput source="project" reference="project">
          <SelectArrayInput optionText="name" />
        </ReferenceArrayInput>
        <TextInput fullWidth source="url" validate={[required()]} />
        <ImageInput
          multiple={false}
          validate={[required()]}
          source="image"
          accept="image/*"
        >
          <ImageField source="url" title="title" />
        </ImageInput>
      </FormTab>
      <FormTab label="saleagency.tab.invoice">
        <LongTextInput source="invoice_to" />
        <LongTextInput source="invoice_company" />
        <LongTextInput source="invoice_address" />
        <NumberInput source="price" />
      </FormTab>
    </TabbedForm>
  );
};

export default SaleAgencyForm;



// WEBPACK FOOTER //
// ./src/components/saleagency/SaleAgencyForm.js